// extracted by mini-css-extract-plugin
export default {"div_line":"DivLine_div_line__bJoA8"};